import { AdScheduledEvent, AdScheduledEventInit, AdScheduledEventParams } from 'common/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class AdScheduledEventsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async createAdScheduledEvent(eventInit: AdScheduledEventInit): Promise<AdScheduledEvent[]> {
    return this.edgeClient.createAdScheduledEvent(eventInit)
  }

  async createAdScheduledEventForInputList(
    inputListId: string,
    event: AdScheduledEventParams,
  ): Promise<AdScheduledEvent[]> {
    return this.edgeClient.triggerAdEventInputList(inputListId, event)
  }
}
